
import { CHANGESPERVISEDETAIL } from '@/store/mutation-types'
export default {
    [CHANGESPERVISEDETAIL](state, payload) {
        state.superViseDetailListData = payload
    },
    SET_UPLOAD_LIST(state, uploadList) {
        state.uploadList = uploadList
    },
    CHANGE_UPLOAD_ITEM_PROCESS(state, { index, process }) {
        state.uploadList.splice(index, 1, {
            ...state.uploadList[index],
            process,
        })
    },
    CHANGE_UPLOAD_ITEM_STATE(state, { index, status }) {
        state.uploadList.splice(index, 1, {
            ...state.uploadList[index],
            status: status,
        })
    },
    TOGGLE_UPLOAD_DIALOG(state, visible) {
        state.uploadDialogVisible = visible
    },
    TOGGLE_THEME(state, theme) {
        localStorage.cly_theme = theme;
        state.theme = theme
    },
    SET_USER_MENU(state, menus) {
        state.userMenus = menus
    },
    SET_ORIGIN_USER_MENU(state, menus) {
        state.originUserMenus = menus
    },
}
